var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSizeTokens = exports.getSizeTokens = void 0;
var getSizeTokens_1 = __importDefault(require("./getSizeTokens"));
exports.getSizeTokens = getSizeTokens_1.default;
var useSizeTokens_1 = __importDefault(require("./useSizeTokens"));
exports.useSizeTokens = useSizeTokens_1.default;
exports.default = useSizeTokens_1.default;
//# sourceMappingURL=index.js.map